import React, { Component } from 'react';
import { PopoverEx as SparkPopover } from '../../../ui/sabre-spark-react-ex';
import { SketchPicker } from 'react-color';
import { toHex } from '../SidebarNavigation/utils/colorUtils';

export class ShadowComponent extends Component {
    constructor(props) {
        super(props);
        this.shadowProperties = this.props.item.groups || [];

        this.updateValueHandler = this.updateValueHandler.bind(this);
        this.updateSliderBackground = this.updateSliderBackground.bind(this);
        this.pickWithEyeDropper = this.pickWithEyeDropper.bind(this);
        this.onInputColorChange = this.onInputColorChange.bind(this);
        this.onInputPickerChange = this.onInputPickerChange.bind(this);
    }

    updateValueHandler(propertyKey, e) {
        const { updateValue } = this.props;
        
        if (e.target && /[^0-9.-]/.test(e.target.value)) {
            return;
        }

        const property = this.shadowProperties.find(prop => prop.key === propertyKey);
        if (!property) return;

        const value = parseFloat(e.target.value);
        
        if (value > property.max) {
            updateValue(propertyKey, property.max);
            return;
        }
        if (value < property.min) {
            updateValue(propertyKey, property.min);
            return;
        }
        
        if (e.target) {
            updateValue(propertyKey, e.target.value);
        }
    }

    updateSliderBackground(targetValue, key) {
        const sliderElement = document.querySelector(`#in-context-slider-${key}`);
        if (!sliderElement) return;
        
        const value = parseFloat(targetValue) || 0;
        const min = parseFloat(sliderElement.min) || 0;
        const max = parseFloat(sliderElement.max) || 100;

        const percentage = ((value - min) / (max - min)) * 100;
        sliderElement.style.setProperty('--slider-progress', `${percentage}%`);
    }

    async pickWithEyeDropper() {
        if (typeof window !== 'undefined' && window.EyeDropper) {
            try {
                const eyeDropper = new EyeDropper();
                const result = await eyeDropper.open();
                this.onInputPickerChange('shadow-color', { hex: result.sRGBHex });
            } catch (e) {
                console.error("Eye dropper failed:", e);
            }
        }
    }

    onInputColorChange(propertyKey, e) {
        const color = e.target.value;
        this.props.updateValue(propertyKey, color);
    }

    onInputPickerChange(propertyKey, color) {
        const isCssColor = CSS.supports('color', color.hex);
        if (isCssColor) {
            this.props.updateValue(propertyKey, color.hex);
        }
    }

    componentDidMount() {
        const { values } = this.props;
        
        this.shadowProperties.forEach(property => {
            const value = values[property.key] || 0;
            this.updateSliderBackground(value, property.key);
        });
    }

    componentDidUpdate(prevProps) {
        const { values } = this.props;
        
        this.shadowProperties.forEach(property => {
            if (prevProps.values[property.key] !== values[property.key]) {
                const value = values[property.key] || 0;
                this.updateSliderBackground(value, property.key);
            }
        });
    }

    renderShadowProperty(property) {
        const { values } = this.props;
        const value = values[property.key] || (property.type === 'color' ? property.defaultValue : 0);

        if (property.type === 'color') {
            const hasEye = (typeof window !== 'undefined' && window.EyeDropper);
            const isInvalid = !CSS.supports('color', value);

            return (
                <div key={property.key} className="shadow-property-container">
                    <div className='in-context-color-label pt-1'>
                        {property.name}
                    </div>
                    <div className={'in-context-color-container'}>
                        <div className="in-context-color-row">
                            <SparkPopover
                                anchorX="right"
                                toggleEl={
                                    <div className="in-context-color-row">
                                        <label className="in-context-color-input" style={{ backgroundColor: value }}>
                                        </label>
                                    </div>
                                }
                            >
                                {hasEye ? (
                                    <div>
                                        <button
                                            type="button"
                                            title="Pick from screen"
                                            className="in-context-menu-button"
                                            onClick={this.pickWithEyeDropper}
                                        >
                                            <span>Pick color from page: </span>
                                            <span className="spark-icon spark-icon-design-dropper"></span>
                                        </button>
                                        <span className="in-context-menu-button-text">
                                            or choose a color from picker:
                                        </span>
                                    </div>
                                ) : null}
                                <SketchPicker 
                                    styles={{
                                        default: {
                                            picker: {
                                                boxShadow: 'none',
                                                border: 'none',
                                            },
                                        },
                                    }} 
                                    color={toHex(value)} 
                                    width={250} 
                                    onChange={(e) => this.onInputPickerChange(property.key, e)} 
                                />
                            </SparkPopover>
                            <input
                                type="text"
                                className="in-context-color-hex-input"
                                value={value}
                                aria-invalid={isInvalid}
                                onChange={e => this.onInputColorChange(property.key, e)}
                            />
                            {isInvalid && (
                                <sub className="in-context-color-error">
                                    Enter a valid color format
                                </sub>
                            )}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div key={property.key} className="shadow-property-container">
                <div className='in-context-color-label pt-1'>
                    {property.name} {property.unit && `(${property.unit})`}
                </div>
                <div className="in-context-slider-container">
                    <input
                        type="range"
                        min={property.min}
                        max={property.max}
                        step={property.step}
                        value={value}
                        onChange={(e) => this.updateValueHandler(property.key, e)}
                        className='in-context-slider'
                        id={`in-context-slider-${property.key}`}
                    />
                    <input
                        type="number"
                        step={property.step}
                        min={property.min}
                        max={property.max}
                        value={value}
                        onChange={(e) => this.updateValueHandler(property.key, e)}
                        className="in-context-input no-spinners"
                    />
                </div>
            </div>
        );
    }

    render() {
        const { item, prefix, open, selectedKey, toggle, keyFor } = this.props;
        const key = keyFor(prefix, item);
        const isOpen = !!open[key];

        return (
            <li key={key} className={'in-context-menu-item' + (selectedKey === item.key ? ' is-selected' : '')}>
                <div className="in-context-menu-label">
                    <button
                        type="button"
                        className="in-context-menu-button"
                        onClick={() => toggle(key)}
                    >
                        {item.name}
                    </button>
                    <button
                        type="button"
                        className="in-context-toggle"
                        onClick={() => toggle(key)}
                        aria-label={isOpen ? 'Collapse' : 'Expand'}
                    >
                        {isOpen ?
                            <i className="spark-icon-arrow-chevron-down spark-icon--fill" /> :
                            <i className="spark-icon-arrow-chevron-up spark-icon--fill" />
                        }
                    </button>
                </div>
                <div className={'in-context-submenu' + (isOpen ? ' open' : '')}>
                    <div className="shadow-controls-container">
                        {this.shadowProperties.map(property => this.renderShadowProperty(property))}
                    </div>
                </div>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/in-context/components/ShadowComponent.js